import { useContext } from "react";
import {
  Modal,
  ModalContext,
  Box,
  Text,
  Button,
  Flex,
  toast,
  useServerResponseTranslation,
  ViewerContext,
} from "dash-ui";
import dayjs from "dayjs";
import { useCancelProductSubscriptionMutation } from "gql/generated.graphql";
import { useTranslation } from "react-i18next";

const CancelTrialModal = () => {
  const { isOpenCurrent, toggleModal, payload } = useContext(ModalContext);
  const { subscription } = useContext(ViewerContext);
  const isOpen = isOpenCurrent["CancelTrialModal"];
  const [cancelProductSubscriptionMutation, { loading }] =
    useCancelProductSubscriptionMutation();
  const translateErrorMessage = useServerResponseTranslation();
  const { t: billingPageLabels } = useTranslation('pages', {
    keyPrefix: 'profilePage.billing',
  });

  const handleCancelTrialClick = () => {
    cancelProductSubscriptionMutation({
      variables: {
        input: {
          cancelationReason: "CANCELED_TRIAL",
        },
      },
      onCompleted: () => {
        toggleModal(false, "CancelTrialModal");
        toast.success(billingPageLabels('subscriptionProductChanged'));
        localStorage.removeItem('notificationDismissTimestamp');
      },
      onError: (error) => {
        toast.error(translateErrorMessage(error, ["common:serverErrors"]));
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Are you sure you want to cancel your trial?"
      onRequestClose={() => toggleModal(false, "CancelTrialModal")}>
      <Box mt={1}>
        <Text>
          This action will cancel your current trial. <br />
          You can keep using the plan's features until{" "}
          {dayjs(subscription?.currentPeriodEndAt).format('YYYY/MM/DD')}. <br />
          You will not be charged and your subscription will change back to your
          previous plan.
        </Text>
      </Box>
      <Flex mt={4} justifyContent="flex-end">
        <Button
          colorVariation="danger"
          mr={2}
          disabled={loading}
          isLoading={loading}
          onClick={handleCancelTrialClick}>
          Cancel trial
        </Button>
        <Button
          variation="outline"
          onClick={() => toggleModal(false, "CancelTrialModal")}>
          Go Back
        </Button>
      </Flex>
    </Modal>
  );
};

export default CancelTrialModal;
